import { render } from "./EiStrengthGrowthProfileBlock.vue?vue&type=template&id=2cec5083&scoped=true"
import script from "./EiStrengthGrowthProfileBlock.vue?vue&type=script&lang=js"
export * from "./EiStrengthGrowthProfileBlock.vue?vue&type=script&lang=js"

import "./EiStrengthGrowthProfileBlock.vue?vue&type=style&index=0&id=2cec5083&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cec5083"]])

export default __exports__